import { type AiBadgeSize } from '@pkgs/components';
import { ImageAiType } from '@pkgs/api';

type GetAiBadgeTranslationKeyParams = {
  size: AiBadgeSize;
  aiType?: ImageAiType;
};

export const getAiBadgeTranslationKey = ({ size, aiType }: GetAiBadgeTranslationKeyParams): string | undefined => {
  if (size === 's' || size === 'm') {
    return 'search.expose.photoGallery.label.ai';
  } else {
    if (aiType === ImageAiType.GENERATED) {
      return 'search.expose.photoGallery.label.aiOptimized';
    }
    if (aiType === ImageAiType.MODIFIED) {
      return 'search.expose.photoGallery.label.aiModified';
    }
    return undefined;
  }
};
